var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"breadcrumbs":[
    {
      text: 'HOME',
      exact: true,
      to: { name: 'home' }
    },
    {
      text: _vm.nombreCategoria,
      disabled: true
    }
  ],"titulo":_vm.nombreCategoria}},[_c('v-container',[_c('v-row',_vm._l((_vm.videos),function(video,i){return _c('v-col',{key:video.id,attrs:{"cols":"12","sm":"6","lg":"4"}},[_c('v-card',{staticClass:"pointer",staticStyle:{"border-radius":"5px"},on:{"click":function($event){return _vm.clickVideo(video.id)}}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{ref:'videoImg-' + i,refInFor:true,attrs:{"cols":"12"}},[_c('v-img',{staticStyle:{"border-top-left-radius":"5px","border-top-right-radius":"5px"},attrs:{"src":video.src,"width":_vm.videoWidth,"height":_vm.videoHeight}})],1),_c('v-col',{staticClass:"pt-2 pb-3 px-2",attrs:{"cols":"12"}},[_c('span',{staticClass:"subtitle-1"},[_vm._v(" "+_vm._s(video.nombre)+" ")])])],1)],1)],1)}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }